module.exports = __webpack_public_path__ + "static/img/11.39f9843.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/2/zh/11.png
// module id = MObS
// module chunks = 0